import Cookies from 'js-cookie';
import { TOKEN_KEY } from '@/config';
import Vue from 'vue';

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 1 }); // 默认1天
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;
  return false;
};

export const hasChild = (item) => {
  return item.children && item.children.length !== 0;
};

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&');
  let paramObj = {};
  keyValueArr.forEach(item => {
    const keyValue = item.split('=');
    paramObj[keyValue[0]] = keyValue[1];
  });
  return paramObj;
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1;
  while (++i < times) {
    callback(i);
  }
};

export const Date2Str = (val) => {
  if (val instanceof Date) {
    return val.getFullYear() + '-' + (val.getMonth() + 1).toString().padStart(2, '0') + '-' + val.getDate().toString().padStart(2, '0')
  }
  if (val > 0) return Int2Date(val);
  return '';
};

export const Int2Date = (val) => {
  if (val === undefined) return '';
  if (val === 0) return '';
  let day = val % 100;
  let mon = parseInt(val / 100, 10) % 100;
  let year = parseInt(val / 10000, 10);
  return year.toString() + '-' + mon.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0');
};

export const Int2ShortDate = (val) => {
  if (val === undefined || val === '') return '';
  val = val % 10000;
  var mm = parseInt(val / 100);
  var dd = val % 100;
  return mm.toString().padStart(2, '0') + '/' + dd.toString().padStart(2, '0');
};

export const Time2Str = (val) => {
  let hh = parseInt(val / 100, 10);
  let mm = parseInt(val % 100, 10);
  let ss = hh.toString().padStart(2, '0') + ':' + mm.toString().padStart(2, '0');
  return ss;
};

export const Date2Int = (val) => {
  if (val === undefined || val === '' || val === null) return 0;
  if (val instanceof Date) {
    return val.getFullYear() * 10000 + (val.getMonth() + 1) * 100 + val.getDate();
  } else {
    return parseInt(val.substr(0, 4), 10) * 10000 + parseInt(val.substr(5, 2), 10) * 100 + parseInt(val.substr(8, 2), 10);
  }
};

export const Time2Int = (val) => {
  return parseInt(val.substr(0, 2), 10) * 100 + parseInt(val.substr(3, 2), 10);
};

export const WeekStr = (w) => {
  const weeks = ['日', '一', '二', '三', '四', '五', '六'];
  return weeks[w];
};

export const Min2Str = (m) => {
  if (m < 60) return m + '分钟';
  let h = parseInt(m / 60);
  return h + '小时' + (m % 60) + '分钟';
};

export const Msg = (s) => {
  Vue.prototype.$swal.fire({
    title: '注意',
    text: s,
    timer: 5000,
    timerProgressBar: true
  });
};
export const MsgError = (s) => {
  Vue.prototype.$swal.fire({
    title: '错误',
    text: s,
    icon: 'error',
    confirmButtonColor: '#d33',
    timer: 5000,
    timerProgressBar: true
  });
};
export const MsgWarn = (s) => {
  Vue.prototype.$swal.fire({
    title: '警告',
    text: s,
    icon: 'warning',
    confirmButtonColor: 'warn',
    timer: 5000,
    timerProgressBar: true
  });
};
